import React, { createContext, useContext } from 'react'
interface UserContextType {
    user: any;
    setUser: React.Dispatch<any>;
}
export const UserContext = createContext<UserContextType | null>(null)

export const useUserContext = () => {
    const context = useContext(UserContext);
    if (context === null) {
        throw new Error('useUserContext must be used within a UserProvider');
    }
    return context;
};
